import React, { useEffect, useState } from "react";
import { API_ciudadanos } from "../../config/apiConfig";
import { toast } from "react-toastify";
import { FaRegCircleXmark, FaPenToSquare, FaX, FaCheck, FaRegTrashCan } from "react-icons/fa6";
import "../../pages/user/css/Curriculum.css";

const Competencias = ({ usuario }) => {
  const nivelesCarnet = ["No", "AM", "A1", "A2", "A", "B", "B1", "C", "C1", "D", "D1", "E"];
  const [competencias, setCompetencias] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [tempCompetencia, setTempCompetencia] = useState("");
  const [tempNivel, setTempNivel] = useState("");
  const [nuevaCompetencia, setNuevaCompetencia] = useState("");
  const [nuevoNivel, setNuevoNivel] = useState("");

  useEffect(() => {
    if (usuario?.userId) {
      fetch(`${API_ciudadanos}/${usuario.userId}/curriculum`)
        .then((res) => res.json())
        .then((data) => {
          const lista = [
            {
              competencia: "Carnet de conducir",
              nivel: data.driversLicense || "No",
              noEliminar: true,
            },
          ];

          if (Array.isArray(data.ComplementarySkills)) {
            lista.push(
              ...data.ComplementarySkills.map((item) => ({
                competencia: item.name,
                nivel: item.level,
                noEliminar: false,
              }))
            );
          }

          setCompetencias(lista);
        })
        .catch((err) => console.error("Error al cargar competencias:", err));
    }
  }, [usuario]);

  const handleEdit = (index) => {
    setEditIndex(index);
    setTempCompetencia(competencias[index].competencia);
    setTempNivel(competencias[index].nivel);
  };

  const handleSaveEdit = async (index) => {
    const item = competencias[index];

    if (item.noEliminar) {
      // Carnet de conducir
      try {
        const res = await fetch(`${API_ciudadanos}/${usuario.userId}/curriculum`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ driversLicense: tempNivel }),
        });
        if (!res.ok) throw new Error();

        // Actualiza el estado local para reflejar el nuevo nivel en pantalla
        const updated = [...competencias];
        updated[index].nivel = tempNivel;
        setCompetencias(updated);

        toast.success("Carnet de conducir actualizado");
      } catch (err) {
        toast.error("Error al actualizar carnet de conducir");
      }
    } else {
      const updated = [...competencias];
      updated[index] = { competencia: tempCompetencia, nivel: tempNivel, noEliminar: false };
      setCompetencias(updated);

      try {
        const body = {
          ComplementarySkills: updated.filter((c) => !c.noEliminar).map((c) => ({ name: c.competencia, level: c.nivel })),
        };
        const res = await fetch(`${API_ciudadanos}/${usuario.userId}/curriculum`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body),
        });
        if (!res.ok) throw new Error();
        toast.success("Competencia actualizada");
      } catch (err) {
        toast.error("Error al guardar la competencia");
      }
    }

    setEditIndex(null);
  };

  const handleCancelEdit = () => {
    setEditIndex(null);
  };

  const handleDelete = async (index) => {
    const actualizadas = competencias.filter((_, i) => i !== index);
    setCompetencias(actualizadas);

    try {
      const body = {
        ComplementarySkills: actualizadas.filter((c) => !c.noEliminar).map((c) => ({ name: c.competencia, level: c.nivel })),
      };
      const res = await fetch(`${API_ciudadanos}/${usuario.userId}/curriculum`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
      if (!res.ok) throw new Error();
      toast.success("Competencia eliminada");
    } catch (err) {
      toast.error("Error al eliminar la competencia");
    }
  };

  const handleAddCompetencia = async () => {
    if (!nuevaCompetencia.trim()) {
      toast.error("Tienes que rellenar competencia");
      return;
    }

    const nuevas = [...competencias, { competencia: nuevaCompetencia.trim(), nivel: nuevoNivel.trim(), noEliminar: false }];
    setCompetencias(nuevas);
    setNuevaCompetencia("");
    setNuevoNivel("");

    try {
      const body = {
        ComplementarySkills: nuevas.filter((c) => !c.noEliminar).map((c) => ({ name: c.competencia, level: c.nivel })),
      };
      const res = await fetch(`${API_ciudadanos}/${usuario.userId}/curriculum`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
      if (!res.ok) throw new Error();
      toast.success("Competencia añadida");
    } catch (err) {
      toast.error("Error al guardar la competencia");
    }
  };

  return (
    <div className="ocupaciones caja-verde">
      <h2 className="blanco fondo-verde align-center mayusculas">
        <FaRegCircleXmark style={{ transform: "rotate(45deg)" }} /> Otros datos de interés
      </h2>

      <ul className="contenido">
        <li className="between titulo verde bold">
          <span className="competencia">ELEMENTO</span>
          <span className="nivel">NIVEL</span>
          <span className="w-65"></span>
        </li>

        {competencias.map((item, index) => (
          <li key={index} className="between">
            {editIndex === index ? (
              <>
                {item.noEliminar ? (
                  <>
                    <span className="competencia">{item.competencia}</span>
                    <select className="nivel" value={tempNivel} onChange={(e) => setTempNivel(e.target.value)}>
                      {nivelesCarnet.map((nivel) => (
                        <option key={nivel} value={nivel}>
                          {nivel}
                        </option>
                      ))}
                    </select>
                  </>
                ) : (
                  <>
                    <input className="competencia" value={tempCompetencia} onChange={(e) => setTempCompetencia(e.target.value)} />
                    <input className="nivel" value={tempNivel} onChange={(e) => setTempNivel(e.target.value)} />
                  </>
                )}
                <div className="editar-cv check botones-acciones flex gap-5">
                  <button aria-label="Guardar cambios" className="fondo-blanco verde" onClick={() => handleSaveEdit(index)}>
                    <FaCheck />
                  </button>
                  <button aria-label="Cancelar cambios" className="fondo-blanco rojo" onClick={handleCancelEdit}>
                    <FaX />
                  </button>
                </div>
              </>
            ) : (
              <>
                <span className="competencia">{item.competencia}</span>
                <span className="nivel capitalize">{item.nivel?.trim() ? item.nivel : "-"}</span>
                <div className="editar-cv botones-acciones flex gap-5">
                  <button className="fondo-blanco" aria-label="Editar la competencia o nivel" onClick={() => handleEdit(index)}>
                    <FaPenToSquare />
                  </button>
                  {!item.noEliminar && (
                    <button className="fondo-blanco eliminar" aria-label="Eliminar esta competencia" onClick={() => handleDelete(index)}>
                      <FaRegTrashCan />
                    </button>
                  )}
                </div>
              </>
            )}
          </li>
        ))}
      </ul>

      <div className="nueva-edicion-rapida flex gap-10 w-100">
        <input type="text" placeholder="Nueva competencia" value={nuevaCompetencia} onChange={(e) => setNuevaCompetencia(e.target.value)} />
        <input type="text" placeholder="Nivel" value={nuevoNivel} onChange={(e) => setNuevoNivel(e.target.value)} />
        <button className="boton estrecho" onClick={handleAddCompetencia}>
          Añadir
        </button>
      </div>
    </div>
  );
};

export default Competencias;
